import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { getComponentName } from "@aviv-unified-frontend/internal";
import { useRuntimeApplication } from "./useRuntimeApplication";
export const createRuntimeWrapper = (id, Component) => {
    const WrappedComponent = (props) => {
        const { setId } = useRuntimeApplication();
        useEffect(() => {
            setId(id);
        }, [setId]);
        return _jsx(Component, { ...props });
    };
    WrappedComponent.displayName = `createRuntimeWrapper(${getComponentName(Component)})`;
    return WrappedComponent;
};
